import bgg from '../assets/bgg.jpeg';
import chef from '../assets/chef.jpeg';
import A from '../assets/A.jpeg';
import gallery01 from '../assets/gallery01.jpeg';
import gallery02 from '../assets/gallery02.jpeg';
import gallery03 from '../assets/gallery03.jpeg';
import gallery04 from '../assets/gallery04.jpeg';
import knife from '../assets/knife.jpeg';
// import logos from '../assets/logos.jpeg';
import menu from '../assets/menu.jpeg';
import overlaybg from '../assets/overlaybg.jpeg';
import sppon from '../assets/sppon.jpeg';
import welcome from '../assets/welcome.jpeg';
// import laurels from '../assets/laurels.jpeg';
import award01 from '../assets/award01.jpeg';
import award02 from '../assets/award02.jpeg';
import award03 from '../assets/award03.jpeg';
import award05 from '../assets/award05.jpeg';
import sign from '../assets/sign.jpeg';
import quote from '../assets/quote.jpeg';
// import alcove from '../assets/alcove.jpeg';

export default {
  bgg,
  chef,
  A,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  knife,
  // logos,
  menu,
  overlaybg,
  sppon,
  welcome,
  // laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  // alcove,
};